import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";

import { TAAConstants } from "../../../views/constants/taa-constants";
import { HeaderService } from "../../services/header.service";
import { AppService } from "../../services/app.service";
import { User } from "../../services/user.model";
import { Configuration } from "../../services/configuration.model";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html"
})
export class HeaderComponent implements OnInit {
  private userProfile: User = new User();
  private iamFaqLink: any;
  public navigateAwayMsg: any;
  private config: Configuration = new Configuration({});
  private homeRouteBlacklist = ["/organization", "/contactus"];
  private organizationNameRouteBlackList = ["/organization", "/contactus"];
  private orgManagementBlackList = ["/organization"];

  private homeUrls = new Map<string, string>([
    ["ACCMGR", "/accmgr"],
    ["NO_ROLE", "/examinees"],
    ["ACCINTCONS", "/intconslanding"],
    ["ACCSUPPORT", "/intsuplanding"]
  ]);

  constructor(
    private router: Router,
    private headerService: HeaderService,
    private appService: AppService,
    private taaConstants: TAAConstants
  ) {
    // Observable.forkJoin([
    //   this.appService.getConfiguration().then(config => {
    //     this.config = config;
    //   }),
    //   this.appService.getUserProfile().then(user => {
    //     this.userProfile = user;
    //   })
    // ]);
    this.appService.getConfiguration().then(config => {
      this.config = config;
    });
    this.appService.getUserProfile().then(user => {
      this.userProfile = user;
    });
  }

  ngOnInit() {
    if (sessionStorage.getItem("selectedOrg")) {
      const data: any = JSON.parse(sessionStorage.getItem("selectedOrg"));
      this.headerService.setSelectedOrgDetails(data);
    }
    this.headerService.setRouter(this.router);
    this.headerService.getSystemProperties().then(properties => {
      this.iamFaqLink = properties["FAQ_LINK"];
    });
  }

  currentRoute() {
    return this.router.url;
  }

  showPopUp(routeTo: any) {
    if (window.confirm(this.taaConstants.getNAVIGATING_AWAY_MESSAGE())) {
      if (routeTo === "ba") {
        this.router.navigate(["/businessAdministration"]);
      } else if (routeTo === "chooseOrg") {
        this.router.navigate(["/organization"]);
      }
    }
  }

  getHomeUrl() {
    return this.homeUrls.get(this.userProfile.role);
  }

  isHomeAllowed() {
    return !this.homeRouteBlacklist.includes(this.router.url);
  }

  isBusinessAdminAllowed() {
    return this.userProfile.role === "ACCMGR";
  }

  isSearchAllowed() {
    return this.userProfile.role === "ACCINTCONS";
  }

  isOrgManagementAllowed() {
    return (
      !this.userProfile.isRoleGlobal() &&
      !this.orgManagementBlackList.includes(this.router.url)
    );
  }

  isOrgNameAllowed() {
    return (
      !this.userProfile.isRoleGlobal() &&
      !this.organizationNameRouteBlackList.includes(this.router.url)
    );
  }

  isShowSupportLinks(): any {
    return this.config.success.enabled
      ? !this.userProfile.isRoleGlobal()
      : true;
  }

  getOrganizationName() {
    const orgDetails = this.headerService.getselectedOrgDetails();
    if (orgDetails.orgName) {
      const stateCode = orgDetails.stateCode || orgDetails.country;
      return `${orgDetails.orgName}, ${orgDetails.cityName}, ${stateCode}`;
    }
  }

  getUserName() {
    const user = this.userProfile;
    return `${user.givenName} ${user.familyName}`;
  }

  getFaqUrl() {
    return this.config.success.enabled
      ? this.config.success.faqUrl
      : this.iamFaqLink;
  }

  isContactUsExternal() {
    return this.config.success.enabled;
  }

  getContactUsUrl() {
    return this.isContactUsExternal()
      ? this.config.success.contactUrl
      : "/contactus";
  }
}



// WEBPACK FOOTER //
// ./client/views/shared/header/header.component.ts